import React from "react";
import SectionHeading from "./SectionHeading";
import { sponsorLogo } from "../config/images";

/**
 * SponsorsSection
 * Props:
 *  - content: siteContent.sponsors -> { heading, subtitle, list: [{name, logo, url}] }
 */
function SponsorsSection({ content }) {
  if (!content || !content.list?.length) return null;

  return (
    <section className="section sponsors-section">
      <div className="container">
        <SectionHeading eyebrow="With thanks to" title={content.heading} subtitle={content.subtitle} />
        <div className="row g-4 justify-content-center align-items-center">
          {content.list.map((sponsor) => {
            const logoImg = (
              <img
                src={sponsorLogo(sponsor.logo)}
                alt={sponsor.name}
                className="sponsor-logo"
              />
            );
            return (
              <div className="col-6 col-md-4 col-lg-2" key={sponsor.id}>
                <div className="sponsor-tile">
                  {sponsor.url ? (
                    <a href={sponsor.url} target="_blank" rel="noreferrer" aria-label={sponsor.name}>
                      {logoImg}
                    </a>
                  ) : (
                    logoImg
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default SponsorsSection;
